<div class="box bg-gradient">
  <div
    nz-row
    class="box card-login-wrapper"
  >
    <app-card-standalone [title]="'PAGE.AUTH.RESET_PASSWORD.TITLE' | translate">
      <app-reset-password-form></app-reset-password-form>
    </app-card-standalone>

    <div class="select-lang-wrapper">
      <app-select-language></app-select-language>
    </div>
    <app-password-requirements [showOldPasswordRule]="true"></app-password-requirements>
  </div>
</div>
